import { takeLatest, put, call, all } from 'redux-saga/effects';
import { getInvoices, getCurrentCharge } from '@api/invoices';
import { DATA_FETCH_STARTED, fetchDataError, fetchDataOk } from '@redux/ducks/invoices';

// Watchers

export function* watchFetchData() {
  yield takeLatest(DATA_FETCH_STARTED, fetchDataTask);
}

// Workers

export function* fetchDataTask(action) {
  try {
    const limit = action?.payload?.invoicesLimit;
    const [invoices, currentCharge] = yield all([call(getInvoices, limit), call(getCurrentCharge)]);

    if (invoices || currentCharge) {
      yield put(fetchDataOk({ invoices, currentCharge }));
    } else {
      yield put(fetchDataError());
    }
  } catch (err) {
    yield put(fetchDataError(err));
  }
}

// Saga

export default function* invoicesSaga() {
  yield all([watchFetchData()]);
}
